import { render } from "./MobileDownloadFile.vue?vue&type=template&id=69100e60&scoped=true&ts=true&lang=pug"
import script from "./MobileDownloadFile.vue?vue&type=script&lang=ts"
export * from "./MobileDownloadFile.vue?vue&type=script&lang=ts"

import "./MobileDownloadFile.vue?vue&type=style&index=0&id=69100e60&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69100e60"]])

export default __exports__